var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.4,
    height: 29.4,
    viewBox: "0 0 29.4 29.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1814085_arrow_forward_next_right_icon",
    "data-name": "1814085_arrow_forward_next_right_icon",
    transform: "translate(-8.1 -8.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Arrow-Left",
    transform: "translate(8.1 8.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M-5.2-290.5a14.7,14.7,0,0,1-14.7-14.7A14.7,14.7,0,0,1-5.2-319.9,14.7,14.7,0,0,1,9.5-305.2,14.7,14.7,0,0,1-5.2-290.5Zm0-27.8a13.151,13.151,0,0,0-13.1,13.1A13.151,13.151,0,0,0-5.2-292.1,13.151,13.151,0,0,0,7.9-305.2,13.151,13.151,0,0,0-5.2-318.3Z",
    transform: "translate(19.9 319.9)",
    fill: "#00d8ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    d: "M2.807-292.847,1.7-294.016l7.2-7.258-7.2-7.258L2.807-309.7l8.426,8.426-8.426,8.426",
    transform: "translate(11.585 315.974)",
    fill: "#00d8ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    d: "M6.062-295.678H-8.7V-297.4H6.062Z",
    transform: "translate(15.589 311.239)",
    fill: "#00d8ad"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.d14f28aa4dc2fd4cabb5810c55063b0d.svg";
export { ForwardRef as ReactComponent };